var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.74955C11.5085 2.57445 11.7163 2.43556 11.9451 2.3408C12.1739 2.24604 12.4191 2.19727 12.6667 2.19727C12.9143 2.19727 13.1595 2.24604 13.3883 2.3408C13.6171 2.43556 13.8249 2.57445 14 2.74955C14.1751 2.92465 14.314 3.13252 14.4088 3.36129C14.5036 3.59006 14.5523 3.83526 14.5523 4.08288C14.5523 4.33051 14.5036 4.5757 14.4088 4.80448C14.314 5.03325 14.1751 5.24112 14 5.41622L5.00004 14.4162L1.33337 15.4162L2.33337 11.7496L11.3334 2.74955Z",
    stroke: "#C7C9D9",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.59cc30304cdaa63293ae80a15e64f1d8.svg";
export { ForwardRef as ReactComponent };